import { render, staticRenderFns } from "./TableWithJump.vue?vue&type=template&id=08f4b3ed&scoped=true"
import script from "./TableWithJump.vue?vue&type=script&lang=js"
export * from "./TableWithJump.vue?vue&type=script&lang=js"
import style0 from "./TableWithJump.vue?vue&type=style&index=0&id=08f4b3ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f4b3ed",
  null
  
)

export default component.exports